/**
 * 下载文件
 * @param {BlobPart} data 下载的数据
 * @param {string} file_name 文件名称（需带后缀）
 * @param {string} type 文件类型 - mime
 */
export function downloadFile(data, file_name, type = 'text/csv') {
  const blob = new Blob([data], { type });
  if ('download' in document.createElement('a')){
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.download = file_name;
    link.href = url;
    link.click();
    // 释放内存
    URL.revokeObjectURL(url);
  } else {
    // ie10下载
    navigator.msSaveOrOpenBlob(blob);
  }
}
